import { z } from "zod";

import { EnrichLinkedinConnectionsMode, ListStatus, ListVisibility } from "@/enum/list.enum";

/** Current LinkedIn connection-enrichment settings for the signed-in user (PREC-3531). */
export const LinkedinEnrichmentSettingsSchema = z.object({
	enrich: z.boolean(),
	mode: z.nativeEnum(EnrichLinkedinConnectionsMode),
	monthlyLimit: z.number().nullable(),
	recentLimit: z.number().nullable(),
	visibility: z.nativeEnum(ListVisibility),
	listId: z.number().nullable(),
	listStatus: z.nativeEnum(ListStatus).nullable(),
	hasLinkedinAccount: z.boolean(),
});

export type LinkedinEnrichmentSettings = z.infer<typeof LinkedinEnrichmentSettingsSchema>;

/** Estimated credit cost of enriching the user's connections under the chosen options. */
export const LinkedinEnrichmentCostPreviewSchema = z.object({
	connectionCount: z.number(),
	perConnectionCredits: z.number(),
	estimatedCredits: z.number(),
	availableCredits: z.number(),
	sufficient: z.boolean(),
});

export type LinkedinEnrichmentCostPreview = z.infer<typeof LinkedinEnrichmentCostPreviewSchema>;

export interface UpdateLinkedinEnrichmentSettings {
	enrich: boolean;
	mode?: EnrichLinkedinConnectionsMode;
	monthlyLimit?: number | null;
	recentLimit?: number | null;
	visibility?: ListVisibility;
}

export interface LinkedinEnrichmentCostPreviewParams {
	mode?: EnrichLinkedinConnectionsMode;
	recentLimit?: number;
}
